import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
/**
* @class MessageCategory
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.messageCategory[0];
* const device = new MessageCategory(record);
* @property {NUMBER} _id - The id of the messageCategory
* @property {STRING} _description - The description of the messageCategory
*/

export default class MessageCategory extends BCMSRecord {
    _id
    _description
    
    constructor (record){     
      super( record  ) 
    }
  }
MessageCategory.define({
    "recordType":"messageCategories",
    "recordIDProp":"id",
    "className" : "MessageCategory",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the message category
         * @property set {NUMBER} - sets the id of the message category
         * @memberof MessageCategory
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),

        /** 
         * @name description
         * @instance
         * @property get {NUMBER} - gets the description of the message category
         * @property set {NUMBER} - sets the description of the message category
         * @memberof MessageCategory
         */
        BCMSRecordProperty.mapToString("description", "_description", "description"),
      ]
})




